import ApiHelper from "../../../common/utils/apiHelper";
import { type SbbTransportApiContext } from "../../../common/utils/transport/sbbTransportApiContext";
import { buildAirlineMilesAndMoreBookingFields } from "../../../common/utils/transport/airlineBookingPayload";
import {
  buildDestinationTransportPayload,
  postDestinationTransportEstimation
} from "../../../common/utils/transport/destinationTransportEstimation";
import { globalActionCreators, selectApiBaseUrl } from "../../../common/store/modules/globalModule";
import { confirmationActionCreators } from "../../../common/store/modules/bookingConfirmationModule";
// helpers
import { isEmailInvalid } from "../../../common/utils/helpers/isEmailInvalid";
import { checkForEmptyField } from "../../../common/utils/helpers/checkForEmptyFields";
import { handleErrorAlert } from "../../../common/utils/helpers/handleErrorAlert";
import { resolveSbbApiPaths } from "./helpers/resolveSbbApiPaths";
import { mapSbbPassengersForApi } from "./helpers/mapSbbPassengersForApi";
import { getLeadGuest, getPassengerCategoryByBirthDate } from "../shared/helpers/leadGuest";

// Toggle mock support for SBB offers endpoint
const USE_MOCK_SBB_INFO = false;

const USE_MOCK_SBB_STATIONS = false;

const MOCK_SBB_STATIONS_RESPONSE = [
  {
    station_id: 8503000,
    name: "Zürich HB",
    latitude: 47.3782,
    longitude: 8.5402
  },
  {
    station_id: 8503016,
    name: "Zürich Flughafen",
    latitude: 47.4506,
    longitude: 8.561
  },
  {
    station_id: 8591190,
    name: "Zürich, Heuried",
    latitude: 47.3682,
    longitude: 8.5094
  },
  {
    station_id: 8511692,
    name: "Zürich, Grünauring",
    latitude: 47.3578,
    longitude: 8.5183
  }
];

const MOCK_SBB_INFO_RESPONSE = {
  provider_title: "Public Transport Tickets",
  provider_description:
    "Public Transport Tickets lorem ipsum dolor sit amet consectetur adipisicing elit. Quisquam, met consectetur adipisicing elit. Quisquam, met consectetur adipisicing elit. Quisquam, quos lorem ipsum dolor sit amet consectetur adipisicing elit. Quisquam, quos lorem is quos lorem ipsum dolor sit amet consectetur adipisicing elit. Quisquam, quos lorem i END END END",
  provider_logo: {
    url: "https://d1o0qt6ld1319s.cloudfront.net/dev/zurich/390c0357-516c-45ae-91b6-152fb9996817/65249b87c14fafd.png",
    name: "SBB"
  },
  name: "Public Transport Tickets",
  type: "SBB",
  main: "ECKWEXQ",
  logo: {
    url: "https://d1o0qt6ld1319s.cloudfront.net/dev/zurich/b683d21a-0759-44c1-aa77-7ef141ec3f7b/78963d891e5df95.png",
    name: "Schweizerische Bundesbahnen (SBB)"
  },
  provider_cover: {
    url: "https://d1o0qt6ld1319s.cloudfront.net/dev/zurich/b683d21a-0759-44c1-aa77-7ef141ec3f7b/fd24851606ab2cc-332x118.png",
    name: "SBB"
  },
  details: {
    custom_route_offer_code: "ECKWEXQ",
    custom_route_cancellation_policy: "Cancellation Policy 123"
  },
  items: [
    {
      id: 551,
      name: "ZSG Short Round Trip",
      type: "SBB",
      offer_type: "route",
      code: "EAPEELG",
      provider_name: "Schweizerische Bundesbahnen (SBB)",
      provider_logo_id: 24756,
      provider_cover_id: 24759,
      provider_logo: {
        url: "https://d1o0qt6ld1319s.cloudfront.net/dev/zurich/b683d21a-0759-44c1-aa77-7ef141ec3f7b/78963d891e5df95.png",
        name: "Schweizerische Bundesbahnen (SBB)"
      },
      offer_image: null,
      departure_address: null,
      destination_address: null,
      airport_pickup: false,
      booking_setting: null,
      time_limit: null,
      terms_and_conditions_url: null,
      cancellation_policy: "Cancellation policy SBB 1"
    },
    {
      id: 777,
      name: "SBB invalid legacy reference",
      type: "SBB",
      offer_type: null,
      code: "EOJRSAB",
      provider_name: "Schweizerische Bundesbahnen (SBB)",
      provider_logo_id: 24756,
      provider_cover_id: 24759,
      provider_logo: {
        url: "https://d1o0qt6ld1319s.cloudfront.net/dev/zurich/b683d21a-0759-44c1-aa77-7ef141ec3f7b/78963d891e5df95.png",
        name: "Schweizerische Bundesbahnen (SBB)"
      },
      offer_image: null,
      departure_address: null,
      destination_address: null,
      airport_pickup: false,
      booking_setting: null,
      time_limit: null,
      terms_and_conditions_url: null,
      cancellation_policy: "Cancellation policy SBB 2"
    },
    {
      id: 721,
      name: "Cypress SBB Test Offer",
      type: "SBB",
      offer_type: "route",
      code: "EPUDRLP",
      provider_name: "Schweizerische Bundesbahnen (SBB)",
      provider_logo_id: 24756,
      provider_cover_id: 24759,
      provider_logo: {
        url: "https://d1o0qt6ld1319s.cloudfront.net/dev/zurich/b683d21a-0759-44c1-aa77-7ef141ec3f7b/78963d891e5df95.png",
        name: "Schweizerische Bundesbahnen (SBB)"
      },
      offer_image: null,
      departure_address: null,
      destination_address: null,
      airport_pickup: false,
      booking_setting: null,
      time_limit: null,
      terms_and_conditions_url: null,
      cancellation_policy: "Cancellation policy SBB 3"
    },
    {
      id: 714,
      name: "Spartageskarte",
      type: "SBB",
      offer_type: "product",
      code: "ECDOLAO",
      provider_name: "Schweizerische Bundesbahnen (SBB)",
      provider_logo_id: 24756,
      provider_cover_id: 24759,
      provider_logo: {
        url: "https://d1o0qt6ld1319s.cloudfront.net/dev/zurich/b683d21a-0759-44c1-aa77-7ef141ec3f7b/78963d891e5df95.png",
        name: "Schweizerische Bundesbahnen (SBB)"
      },
      offer_image: null,
      departure_address: null,
      destination_address: null,
      airport_pickup: false,
      booking_setting: null,
      time_limit: null,
      terms_and_conditions_url: null,
      cancellation_policy: "Cancellation policy SBB 4"
    },
    {
      id: 713,
      name: "Tageskarte zum Halbtax",
      type: "SBB",
      offer_type: "product",
      code: "EDDGDPH",
      provider_name: "Schweizerische Bundesbahnen (SBB)",
      provider_logo_id: 24756,
      provider_cover_id: 24759,
      provider_logo: {
        url: "https://d1o0qt6ld1319s.cloudfront.net/dev/zurich/b683d21a-0759-44c1-aa77-7ef141ec3f7b/78963d891e5df95.png",
        name: "Schweizerische Bundesbahnen (SBB)"
      },
      offer_image: null,
      departure_address: null,
      destination_address: null,
      airport_pickup: false,
      booking_setting: null,
      time_limit: null,
      terms_and_conditions_url: null,
      cancellation_policy: "Cancellation policy SBB 5"
    }
  ]
};

export const sbbActionTypes = {
  CALL_SBB_API: "CALL_SBB_API",
  TOGGLE_QUICK_SELECTION_ERROR: "TOGGLE_QUICK_SELECTION_ERROR",
  UPDATE_PASSENGERS_LIST: "UPDATE_PASSENGERS_LIST",
  SET_PREBOOK_INFO_PRICE: "SET_PREBOOK_INFO_PRICE",
  UPDATE_DATA_FOR_BOOKING: "UPDATE_DATA_FOR_BOOKING",
  UPDATE_PREBOOK_API_ERROR: "UPDATE_PREBOOK_API_ERROR",
  SET_SBB_BOOKING_RESPONSE_DATA: "SET_SBB_BOOKING_RESPONSE_DATA",
  TOGGLE_SBB_BOOKING_ERROR: "TOGGLE_SBB_BOOKING_ERROR",
  TOGGLE_SBB_PAYMENT_MODAL: "TOGGLE_SBB_PAYMENT_MODAL",
  SET_ACTIVE_QUICK_SELECTION_OFFER: "SET_ACTIVE_QUICK_SELECTION_OFFER",
  RESET_SBB_STATE: "RESET_SBB_STATE",
  SEARCH_SBB_STATIONS: "SEARCH_SBB_STATIONS",
  LAST_MILE_ROUTE_LOADING: "LAST_MILE_ROUTE_LOADING",
  LAST_MILE_ROUTE_SUCCESS: "LAST_MILE_ROUTE_SUCCESS",
  LAST_MILE_ROUTE_ERROR: "LAST_MILE_ROUTE_ERROR"
};

export const initialState = {
  sbbData: null,
  sbbQuickSelection: [],
  sbbCustomRouteCode: null,
  quickSelectionError: false,
  sbbActiveOffer: null,
  passengerList: [
    {
      first_name: "",
      last_name: "",
      birthdate: new Date("2001-01-01"),
      member_card: false,
      hasRemove: false
    }
  ],
  prebookPriceInfo: null,
  errorPrebook: null,
  dataForBooking: {
    commentForm: "",
    emailForm: "",
    acceptTerms: false
  },
  sbbBookingResponseData: null,
  sbbBookingError: false,
  showSbbPaymentModal: false,
  selectedStationFrom: null,
  selectedStationTo: null,
  lastMileRoute: null as null | {
    distance_meters?: number | null;
    duration_seconds?: number | null;
    travel_mode?: string | null;
    google_maps_url?: string | null;
  },
  isLastMileRouteLoading: false,
  lastMileRouteError: null as string | null
};

const sbbModule = (state = initialState, action: any) => {
  switch (action.type) {
    case sbbActionTypes.CALL_SBB_API:
      return {
        ...state,
        sbbData: action.sbbData,
        sbbQuickSelection: action.sbbQuickSelection,
        sbbCustomRouteCode: action.sbbCustomRouteCode
      };
    case sbbActionTypes.UPDATE_PASSENGERS_LIST:
      return {
        ...state,
        passengerList: action.passengerList
      };
    case sbbActionTypes.SET_PREBOOK_INFO_PRICE:
      return {
        ...state,
        prebookPriceInfo: action.prebookPriceInfo
      };
    case sbbActionTypes.UPDATE_DATA_FOR_BOOKING:
      return {
        ...state,
        dataForBooking: action.dataForBooking
      };
    case sbbActionTypes.UPDATE_PREBOOK_API_ERROR:
      return {
        ...state,
        errorPrebook: action.errorPrebook
      };
    case sbbActionTypes.SET_SBB_BOOKING_RESPONSE_DATA:
      return {
        ...state,
        sbbBookingResponseData: action.sbbBookingResponseData
      };
    case sbbActionTypes.TOGGLE_SBB_BOOKING_ERROR:
      return {
        ...state,
        sbbBookingError: action.sbbBookingError
      };
    case sbbActionTypes.TOGGLE_SBB_PAYMENT_MODAL:
      return {
        ...state,
        showSbbPaymentModal: action.showSbbPaymentModal
      };
    case sbbActionTypes.SET_ACTIVE_QUICK_SELECTION_OFFER:
      return {
        ...state,
        sbbActiveOffer: action.sbbActiveOffer
      };
    case sbbActionTypes.RESET_SBB_STATE:
      return {
        ...state,
        ...initialState
      };
    case sbbActionTypes.SEARCH_SBB_STATIONS:
      return {
        ...state,
        selectedStationFrom: action.selectedStationFrom,
        selectedStationTo: action.selectedStationTo
      };
    case sbbActionTypes.LAST_MILE_ROUTE_LOADING:
      return {
        ...state,
        isLastMileRouteLoading: Boolean(action.isLoading),
        ...(action.isLoading
          ? {
              lastMileRouteError: null
            }
          : {})
      };
    case sbbActionTypes.LAST_MILE_ROUTE_SUCCESS:
      return {
        ...state,
        isLastMileRouteLoading: false,
        lastMileRouteError: null,
        lastMileRoute: action.lastMileRoute ?? null
      };
    case sbbActionTypes.LAST_MILE_ROUTE_ERROR:
      return {
        ...state,
        isLastMileRouteLoading: false,
        lastMileRoute: null,
        lastMileRouteError: action.error ?? "transport.lastMileError"
      };

    default:
      return state;
  }
};

export default sbbModule;

export const sbbActionCreators = {
  getSbbInfoAction:
    (isZurichCard: boolean, transportContext: SbbTransportApiContext) => async (dispatch: any, getState: any) => {
      const apiUrl = selectApiBaseUrl(getState());
      const paths = resolveSbbApiPaths(isZurichCard, transportContext);

      // turn on the loader
      dispatch(globalActionCreators?.toggleGlobalLoaderAction(true));
      // reset error state
      dispatch({
        type: sbbActionTypes.TOGGLE_QUICK_SELECTION_ERROR,
        quickSelectionError: false
      });

      if (paths.kind === "invalid_airline") {
        dispatch({
          type: sbbActionTypes.TOGGLE_QUICK_SELECTION_ERROR,
          quickSelectionError: true
        });
        dispatch(globalActionCreators?.toggleGlobalLoaderAction(false));
        return;
      }

      try {
        const transportUrl = paths.infoPath;
        let data: any;

        // keep this aligned with SwissTravelPass mock pattern
        if (USE_MOCK_SBB_INFO && !isZurichCard) {
          await new Promise(resolve => setTimeout(resolve, 300));
          data = MOCK_SBB_INFO_RESPONSE;
        } else {
          const res = await ApiHelper.get(`${apiUrl}/${transportUrl}`);
          // Catalog load is synchronous HTTP (guest + airline). WebSocket follows POST estimation only.
          data = res?.data;
        }

        dispatch({
          type: sbbActionTypes.CALL_SBB_API,
          sbbQuickSelection: data?.items || [],
          sbbCustomRouteCode: data?.main || null,
          sbbData: data || null
        });
      } catch (err: any) {
        dispatch({
          type: sbbActionTypes.TOGGLE_QUICK_SELECTION_ERROR,
          quickSelectionError: true
        });
      } finally {
        dispatch(globalActionCreators?.toggleGlobalLoaderAction(false));
      }
    },
  searchSbbStationsAction:
    (query: string, direction: string, isZurichCard: boolean, transportContext: SbbTransportApiContext) =>
    async (dispatch: any, getState: any) => {
      const apiUrl = selectApiBaseUrl(getState());
      const paths = resolveSbbApiPaths(isZurichCard, transportContext);
      const selectedStationFrom = getState().sbb.selectedStationFrom;
      const selectedStationTo = getState().sbb.selectedStationTo;

      if (paths.kind === "invalid_airline") {
        return;
      }

      // keep this aligned with getSbbInfoAction mock pattern
      if (USE_MOCK_SBB_STATIONS && !isZurichCard) {
        await new Promise(resolve => setTimeout(resolve, 300));
        const data = MOCK_SBB_STATIONS_RESPONSE;

        if (direction === "from") {
          dispatch({
            type: sbbActionTypes.SEARCH_SBB_STATIONS,
            selectedStationFrom: data,
            selectedStationTo: selectedStationTo
          });
        }
        if (direction === "to") {
          dispatch({
            type: sbbActionTypes.SEARCH_SBB_STATIONS,
            selectedStationTo: data,
            selectedStationFrom: selectedStationFrom
          });
        }
        return data;
      }

      if (query?.length > 2 && apiUrl) {
        try {
          const res = await ApiHelper.get(paths.stationsSearchUrl(apiUrl, query));

          if (direction === "from") {
            dispatch({
              type: sbbActionTypes.SEARCH_SBB_STATIONS,
              selectedStationFrom: res?.data,
              selectedStationTo: selectedStationTo
            });
          }
          if (direction === "to") {
            dispatch({
              type: sbbActionTypes.SEARCH_SBB_STATIONS,
              selectedStationTo: res?.data,
              selectedStationFrom: selectedStationFrom
            });
          }
          return res?.data;
        } catch (err: any) {}
      }
    },
  getLastMileRouteAction:
    ({
      departureLatitude,
      departureLongitude,
      destinationPlaceId,
      travelMode
    }: {
      departureLatitude: number;
      departureLongitude: number;
      destinationPlaceId: string;
      travelMode?: "walking" | "driving" | "transit" | "bicycling" | string;
    }) =>
    async (dispatch: any, getState: any) => {
      const apiUrl = selectApiBaseUrl(getState());
      const safePlaceId = typeof destinationPlaceId === "string" ? destinationPlaceId.trim() : "";

      if (!apiUrl || !safePlaceId) {
        return;
      }

      dispatch({
        type: sbbActionTypes.LAST_MILE_ROUTE_LOADING,
        isLoading: true
      });

      try {
        const query = [
          `departureLatitude=${encodeURIComponent(String(departureLatitude))}`,
          `departureLongitude=${encodeURIComponent(String(departureLongitude))}`,
          `destinationPlaceId=${encodeURIComponent(safePlaceId)}`,
          `travelMode=${encodeURIComponent(travelMode || "walking")}`
        ].join("&");
        const url = `${apiUrl}/v1/airports/last-mile-route?${query}`;
        const res = await ApiHelper.get(url);

        dispatch({
          type: sbbActionTypes.LAST_MILE_ROUTE_SUCCESS,
          lastMileRoute: res?.data ?? null
        });
        return res?.data;
      } catch (err: any) {
        dispatch({
          type: sbbActionTypes.LAST_MILE_ROUTE_ERROR,
          error: "transport.lastMileError"
        });
      } finally {
        dispatch({
          type: sbbActionTypes.LAST_MILE_ROUTE_LOADING,
          isLoading: false
        });
      }
    },
  updatePassengersAction: (passengerList: Array<any>) => (dispatch: any) => {
    dispatch({
      type: sbbActionTypes.UPDATE_PASSENGERS_LIST,
      passengerList
    });
  },
  getPriceSbbPrebookAction:
    (params: any, isZurichCard: boolean, transportContext: SbbTransportApiContext) =>
    async (dispatch: any, getState: any) => {
      const apiUrl = selectApiBaseUrl(getState()) || "";
      const passengerListState = getState().sbb.passengerList;

      const rawStartDate = typeof params?.start_date === "string" ? params.start_date : "";
      const [datePart, timePart] = rawStartDate.split(" ");

      const details: Record<string, any> = {
        passengers: mapSbbPassengersForApi(passengerListState),
        qualityOfService: params?.qualityOfService,
        ...(isZurichCard
          ? {}
          : {
              direction: params?.direction,
              departure: params?.origin ?? null,
              destination: params?.destination ?? null
            })
      };

      const basePayload = buildDestinationTransportPayload({
        date: datePart || "",
        time: timePart || "",
        departureAddress: params?.departureAddress ?? null,
        departureAddressId: params?.departureAddressId ?? null,
        destinationAddress: params?.destinationAddress ?? null,
        destinationAddressId: params?.destinationAddressId ?? null,
        milesAndMore: params?.milesAndMore ?? "",
        offerCode: params?.offer_code,
        details
      });

      const apiParams: Record<string, any> = {
        ...basePayload,
        attributes: Array.isArray(params?.attributes) ? params.attributes : []
      };

      // turn on the loader
      dispatch(globalActionCreators?.toggleGlobalLoaderAction(true));
      // reset error state
      dispatch({
        type: sbbActionTypes.UPDATE_PREBOOK_API_ERROR,
        errorPrebook: null
      });

      try {
        const resData = await postDestinationTransportEstimation({
          apiUrl,
          transportContext,
          payload: apiParams,
          v2: { path: isZurichCard ? "v2/transport/zurich_card" : "v2/transport/sbb" },
          airline: isZurichCard
            ? undefined
            : { path: iataCode => `v1/airports/${encodeURIComponent(iataCode)}/transports/SBB` }
        });
        dispatch({
          type: sbbActionTypes.SET_PREBOOK_INFO_PRICE,
          prebookPriceInfo: resData
        });
        return resData;
      } catch (err: any) {
        dispatch({
          type: sbbActionTypes.SET_PREBOOK_INFO_PRICE,
          prebookPriceInfo: null
        });
        dispatch({
          type: sbbActionTypes.UPDATE_PREBOOK_API_ERROR,
          errorPrebook: err?.response.data
        });
      } finally {
        dispatch(globalActionCreators?.toggleGlobalLoaderAction(false));
      }
    },
  resetPrebookDataInfoAction: () => (dispatch: any) => {
    dispatch({
      type: sbbActionTypes.SET_PREBOOK_INFO_PRICE,
      prebookPriceInfo: null
    });
  },
  updateFormForBookingAction:
    (dataForBooking: { commentForm: string; emailForm: string; acceptTerms?: boolean }) => (dispatch: any) => {
      dispatch({
        type: sbbActionTypes.UPDATE_DATA_FOR_BOOKING,
        dataForBooking: dataForBooking
      });
    },
  toggleSbbBookingErrorAction: (sbbBookingError: boolean) => (dispatch: any) => {
    dispatch({
      type: sbbActionTypes.TOGGLE_SBB_BOOKING_ERROR,
      sbbBookingError
    });
  },
  buySbbTicketAction:
    (params: any, navigate: any, isZurichCard: boolean, transportContext: SbbTransportApiContext) =>
    async (dispatch: any, getState: any) => {
      const dataForBookingState = getState().sbb.dataForBooking;
      const passengerListState = getState().sbb.passengerList;
      const prebookPriceInfoState = getState().sbb.prebookPriceInfo;
      const paths = resolveSbbApiPaths(isZurichCard, transportContext);

      // remove bookingResponseDataStorage from storage, before setting it again
      localStorage.removeItem("bookingResponseDataStorage");

      let errorField = {
        emailForm: false,
        commentForm: false,
        acceptTerms: false
      };
      let errorCheck = true;

      if (isEmailInvalid(dataForBookingState.emailForm) || checkForEmptyField(dataForBookingState.emailForm)) {
        errorField.emailForm = true;
        errorCheck = false;
      }

      if (dataForBookingState?.commentForm !== "" && dataForBookingState?.commentForm?.length < 3) {
        errorField.commentForm = true;
        errorCheck = false;
      }

      if (isZurichCard && !dataForBookingState?.acceptTerms) {
        errorField.acceptTerms = true;
        errorCheck = false;
      }

      if (paths.kind === "invalid_airline") {
        dispatch(sbbActionCreators?.toggleSbbBookingErrorAction(true));
        return;
      }

      if (!errorCheck) {
        dispatch({ type: "TOGGLE_ERROR_FIELD", errorExists: true, errorField: errorField });
      } else {
        const apiUrl = selectApiBaseUrl(getState());
        const language = localStorage.getItem("i18nextLng");

        dispatch(globalActionCreators?.toggleGlobalLoaderAction(true));
        dispatch({ type: "TOGGLE_ERROR_FIELD", errorExists: false, errorField: errorField });

        // The lead guest is the booking contact; there is no separate guest name field.
        // Age is checked on the travel date (`start_date` is a unix timestamp in seconds).
        const travelDate = typeof params?.start_date === "number" ? new Date(params.start_date * 1000) : null;
        const leadGuest = getLeadGuest(passengerListState, (passenger: any) =>
          getPassengerCategoryByBirthDate(passenger?.birthdate, travelDate)
        );

        const apiParams = {
          summary: {
            start_date: params?.start_date,
            adult: passengerListState?.length,
            timeslot: params?.timeslot,
            offer_code: params?.offer_code
          },
          personal_information: {
            first_name: leadGuest?.first_name,
            last_name: leadGuest?.last_name,
            email: dataForBookingState?.emailForm,
            phone: "",
            comment: dataForBookingState?.commentForm ? dataForBookingState?.commentForm : null
          },
          ...buildAirlineMilesAndMoreBookingFields(transportContext),
          hotel_stay_code: getState().tenant.tenantInfo?.code,
          session_id: prebookPriceInfoState?.details?.session_id
        };

        try {
          const response = await ApiHelper.post(`${apiUrl}/${paths.bookingsPath}`, {}, apiParams);

          localStorage.setItem("bookingResponseDataStorage", JSON.stringify(response.data));

          // We can get API status 200, with booking_status=error --> in that case we should show error page instead of Payment Modal / Confirmation Page
          if (response.data?.booking_status === "error") {
            dispatch(sbbActionCreators?.toggleSbbBookingErrorAction(true));
            return;
          } else {
            dispatch(sbbActionCreators?.toggleSbbBookingErrorAction(false));

            dispatch({
              type: sbbActionTypes.SET_SBB_BOOKING_RESPONSE_DATA,
              sbbBookingResponseData: response.data
            });

            // If price is 0 we will get payment_status=paid from API --> and we should redirect user directly to the /confirmation page (without payment modal)
            if (response.data?.payment_status === "paid") {
              // call booking status action, in order to set new value to the bookingStatus state
              await dispatch(confirmationActionCreators?.getBookingStatusAction());
              // redirect to confirmation
              const confirmationPath: "zurich_card" | "sbb" = isZurichCard ? "zurich_card" : "sbb";
              await navigate(`/${language}/transport/${confirmationPath}/confirmation`, { replace: true });
            } else {
              // open payment modal (if status is not booked)
              dispatch(sbbActionCreators?.toggleSbbPaymentModalAction(true));
            }
          }
        } catch (error: any) {
          handleErrorAlert(error);
          dispatch(sbbActionCreators?.toggleSbbBookingErrorAction(true));
        } finally {
          dispatch(globalActionCreators?.toggleGlobalLoaderAction(false));
        }
      }
    },
  toggleSbbPaymentModalAction: (showSbbPaymentModal: boolean) => (dispatch: any) => {
    dispatch({
      type: sbbActionTypes.TOGGLE_SBB_PAYMENT_MODAL,
      showSbbPaymentModal
    });
  },
  setSbbActiveOfferAction: (sbbActiveOffer: any) => (dispatch: any) => {
    dispatch({
      type: sbbActionTypes.SET_ACTIVE_QUICK_SELECTION_OFFER,
      sbbActiveOffer
    });
  },
  resetSbbStateAction: () => (dispatch: any) => {
    dispatch({
      type: sbbActionTypes.RESET_SBB_STATE
    });
  }
};
